import React from 'react';
import { ArrowLeft } from 'lucide-react';

const SentimentAnalysis = ({ setCurrentPage }) => {
  // Replace this URL with your actual Looker Studio report embed URL
  const lookerReportUrl = "https://lookerstudio.google.com/embed/reporting/8365d6d3-db3c-47e3-97a4-0dcce88cdc52/page/tEnnC";

  return (
    <div className="min-h-screen flex flex-col">
      <button 
        onClick={() => setCurrentPage('home')} 
        className="mb-4 flex items-center text-[rgb(100,204,201)] hover:underline"
      >
        <ArrowLeft className="mr-2" /> Back to Dashboard
      </button>
      <h2 className="text-2xl font-bold mb-4">Sentiment Analysis Tool</h2>
      
      <div className="flex-grow">
        <iframe
          src={lookerReportUrl}
          title='Sentiment Analysis Report'
          frameBorder="0"
          style={{
            width: '100%',
            height: '100%',
            aspectRatio: '16/9',
            maxHeight: '80vh'
          }}
          allowFullScreen
        />
      </div>
      
      <div className="data-summary">
    <div className="company-section">
        <div className="company-name">Sonneil Homes</div>
        
        <div className="mentions">
            <div className="aspect-title">Menciones destacadas:</div>
            <ul className="mentions-list">
                <li>David: 15 positivas, 0 negativas</li>
                <li>Andrés: 3 positivas, 0 negativas</li>
                <li>Tatiana: 2 positivas, 0 negativas</li>
                <li>Jan: 2 positivas, 0 negativas</li>
            </ul>
        </div>

        <div className="aspect-section">
            <div className="aspect-title">Aspectos positivos relevantes:</div>
            <ul>
                <li>Profesionalidad del personal</li>
                <li>Atención al cliente excepcional</li>
                <li>Explicaciones claras y detalladas</li>
                <li>Rapidez de respuesta</li>
                <li>Conocimiento del producto</li>
            </ul>
        </div>

        <div className="aspect-section">
            <div className="aspect-title">Aspectos negativos relevantes:</div>
            <p>No se mencionan aspectos negativos significativos</p>
        </div>

        <div className="aspect-section">
            <div className="aspect-title">Opiniones recurrentes:</div>
            <ul>
                <li>Excelente atención al cliente</li>
                <li>Explicaciones detalladas y claras</li>
                <li>Agentes bien informados</li>
                <li>Trato amable y cercano</li>
            </ul>
        </div>

        <div className="evaluation">
            <div className="aspect-title">Evaluación general:</div>
            <p>Las reseñas son overwhelmingly positivas, con la mayoría de los clientes otorgando 5 estrellas. La empresa y su personal, especialmente David, reciben elogios consistentes por su profesionalidad, atención al cliente y conocimiento del producto. Los clientes se sienten bien atendidos, informados y apoyados durante todo el proceso.</p>
        </div>
    </div>

    <div className="company-section">
        <div className="company-name">Competencia</div>
        
        <div className="mentions">
            <div className="aspect-title">Menciones destacadas:</div>
            <ul className="mentions-list">
                <li>Florin: 6 positivas, 0 negativas</li>
                <li>Rebecca: 5 positivas, 0 negativas</li>
                <li>Neil: 4 positivas, 0 negativas</li>
            </ul>
        </div>

        <div className="aspect-section">
            <div className="aspect-title">Aspectos positivos relevantes:</div>
            <ul>
                <li>Profesionalismo y competencia del personal</li>
                <li>Servicio al cliente excepcional</li>
                <li>Comunicación efectiva</li>
                <li>Conocimiento del mercado</li>
            </ul>
        </div>

        <div className="aspect-section">
            <div className="aspect-title">Aspectos negativos relevantes:</div>
            <ul>
                <li>Problemas post-venta</li>
                <li>Enfoque formalista en reparaciones</li>
                <li>Falta de comunicación en algunos casos</li>
            </ul>
        </div>

        <div className="evaluation">
            <div className="aspect-title">Evaluación general:</div>
            <p>La evaluación general es muy positiva, con 43 de 46 reseñas de 5 estrellas. Sin embargo, existen algunas áreas de mejora, principalmente en el servicio post-venta y la comunicación a largo plazo con los clientes. La agencia destaca en el proceso de compra/venta pero podría mejorar sus procesos post-venta.</p>
        </div>
        </div>
      </div>
      
      <style>
        {`
          .data-summary { margin: 20px; font-family: Arial, sans-serif; }
          .company-section { margin-bottom: 30px; border: 1px solid #ddd; padding: 20px; border-radius: 5px; }
          .company-name { font-size: 24px; font-weight: bold; margin-bottom: 15px; color: #333; }
          .mentions { margin-bottom: 15px; }
          .mentions-list { list-style-type: none; padding-left: 0; }
          .aspect-section { margin-bottom: 15px; }
          .aspect-title { font-weight: bold; color: #444; margin-bottom: 10px; }
          .evaluation { background-color: #f9f9f9; padding: 15px; border-radius: 5px; }
        `}
      </style>
    </div>
  );
};

export default SentimentAnalysis;